import {
  bsc,
  bscTestnet,
  kaia,
  kairos,
  mainnet,
  polygon,
  polygonAmoy,
} from "@reown/appkit/networks"

import { WagmiAdapter } from "@reown/appkit-adapter-wagmi"
import { createStorage } from "@wagmi/core"

const shouldShowTestnet = import.meta.env.VITE_SHOULD_SHOW_TESTNET === "true"
export const IS_ASSET_MOVEMENT_ENABLED =
  import.meta.env.VITE_ENABLE_ASSET_MOVEMENT === "true"
export const projectId = import.meta.env.VITE_REOWN_PROJECT_ID

if (!projectId) {
  throw new Error("VITE_REOWN_PROJECT_ID is not defined")
}

export const networks = shouldShowTestnet
  ? [mainnet, bsc, polygon, kaia, bscTestnet, polygonAmoy, kairos]
  : [mainnet, bsc, polygon, kaia]

export const NETWORK_BY_ID = Object.fromEntries(
  networks.map((network) => [network.id, network])
)

/**
 * Chains shown in the policy-create network selector.
 * Add chains here when backend support is confirmed.
 * This is intentionally separate from `networks` (wagmi wallet connection)
 * so analytics/tx-link support can be added independently.
 *
 * Currently excluded from policy create (not yet supported by backend):
 *   - kaia   (8217)
 *   - kairos (1001)
 */
export const POLICY_NETWORKS = shouldShowTestnet
  ? [mainnet, bsc, polygon, bscTestnet, polygonAmoy]
  : [mainnet, bsc, polygon]

export const wagmiAdapter = new WagmiAdapter({
  storage: createStorage({
    storage: typeof window !== "undefined" ? window.localStorage : undefined,
  }),
  ssr: false,
  projectId,
  networks,
})

export const config = wagmiAdapter.wagmiConfig
